// document.addEventListener("DOMContentLoaded", () => {
//     (function switchTableTab() {
//         const tableTabsContainer = document.querySelector('.solutions-table-tabs');
//         const tables = document.querySelectorAll('.solutions-table');

//         if (tableTabsContainer) {
//             const tableTabs = tableTabsContainer.querySelectorAll('.solutions-table-tab');

//             tableTabsContainer.addEventListener('click', (e) => {
//                 tableTabs.forEach((tab) => {
//                     tab.classList.remove('active');
//                 })

//                 const currentTab = e.target.closest('.solutions-table-tab');

//                 if (currentTab) {
//                     currentTab.classList.add('active');
//                     tableTabsContainer.scrollLeft = currentTab.getBoundingClientRect().left - 40;

//                     tables.forEach((table) => {
//                         if (table.dataset.table === currentTab.dataset.tab) {
//                             table.classList.add('active');
//                         } else {
//                             table.classList.remove('active');
//                         }
//                     })
//                 }
//             })
//         }
//     }());
// })

const solutionsTableModule =
    solutionsTableModule ||
    (() => {
        const status = {
            isInitialized: false,
        }
        
        function switchTableTab() {
            const tableBlocks = document.querySelectorAll('.solutions-table-block');
            if (tableBlocks) {
                tableBlocks.forEach((tableBlock) => {
                    const tableTabsContainers = tableBlock.querySelectorAll(".solutions-table-tabs");
                    const tables = tableBlock.querySelectorAll(".solutions-table");
                    tableTabsContainers.forEach((tableTabsContainer, index) => {
                        if (tableTabsContainer) {
                            const tableTabs = tableTabsContainer.querySelectorAll(".solutions-table-tab")
                            tableTabsContainer.addEventListener("click", (e) => {
                                tableTabs.forEach((tab) => {
                                    tab.classList.remove("active")
                                })
            
                                const currentTab = e.target.closest(".solutions-table-tab")
            
                                if (currentTab) {
                                    currentTab.classList.add("active")
                                    tableTabsContainer.scrollLeft = currentTab.getBoundingClientRect().left - 40
                                    renderActiveTabItem()
                                    tables.forEach((table) => {
                                            if (table.dataset.table === currentTab.dataset.tab) {
                                                table.classList.add("active")
                                            } else {
                                                table.classList.remove("active")
                                            }
                                    })
                                }
                            })
                        }
                    })
                })
            }
        }

        const calculateTabBulletSnapgrid = () => {
            const tableTabs = document.querySelectorAll(".solutions-table-tabs")
            if (tableTabs.length > 0) {
                tableTabs.forEach((item) => {
                    const tabItems = item.querySelectorAll(".solutions-table-tab")
                    if (tabItems.length > 0) {
                        tabItems.forEach((tabItem) => {
                            const bulletWidth = tabItem.getBoundingClientRect().width
                            tabItem.setAttribute("data-bullet-width", bulletWidth + "px")

                            const bulletOffsetLeft = tabItem.offsetLeft
                            tabItem.setAttribute("data-bullet-offset-left", bulletOffsetLeft + "px")
                        })
                    }
                })
            }
        }

        const renderActiveTabItem = () => {
            const tableTabs = document.querySelectorAll(".solutions-table-tabs")
            if (tableTabs.length > 0) {
                tableTabs.forEach((item) => {
                    const activeItem = item.querySelector(".solutions-table-tab.active")
                    if (!activeItem) {
                        item.style.removeProperty("--bullet-width")
                        item.style.removeProperty("--bullet-offset-left")
                    } else {
                        const bulletWidth = activeItem.dataset.bulletWidth
                        const bulletOffsetLeft = activeItem.dataset.bulletOffsetLeft
                        item.style.setProperty("--bullet-offset-left", `calc(${bulletOffsetLeft})`)
                        item.style.setProperty("--bullet-width", `calc(${bulletWidth})`)
                    }
                })
            }
        }

        const setUp = () => {
            switchTableTab()
            calculateTabBulletSnapgrid()
            renderActiveTabItem()

            window.addEventListener("resize", () => {
                calculateTabBulletSnapgrid()
                renderActiveTabItem()
            })
        }

        const init = () => {
            if (status.isInitialized) return
            setUp()
            status.isInitialized = true
        }
        return {
            init,
        }
    })()

window.addEventListener("load", solutionsTableModule.init)
